import { render, staticRenderFns } from "./exhibition-release-new-all.vue?vue&type=template&id=06e2ff73&scoped=true&"
import script from "./exhibition-release-new-all.vue?vue&type=script&lang=js&"
export * from "./exhibition-release-new-all.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-release-new-all.vue?vue&type=style&index=0&id=06e2ff73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e2ff73",
  null
  
)

export default component.exports